import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['dropdownBlock']

  toggleSelect(event) {
    event.currentTarget.querySelector('.dropdown').classList.toggle('visible')
  }

}